module.exports = __webpack_public_path__ + "img/Bougie_mariage.d1340af.jpg";